import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTIcon} from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
}

const MenuItemSite: React.FC<Props> = ({
  to,
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
}) => {
  const {pathname} = useLocation()
  const [hoveredItem, setHoveredItem] = useState(false) // Specify the type here
  const handleHover = (isHovered: boolean) => {
    setHoveredItem(isHovered)
  }
  return (
    <div className='menu-item '>
      <Link
        className={clsx('bg-gray-200  rounded p-2 ', {
          'bg-warning rounded p-2 text-white ': checkIsActive(pathname, to),
        })}
        to={to}
        onMouseEnter={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
      >
        <span>{title}</span>
      </Link>
    </div>
  )
}

export {MenuItemSite}
